module.exports = __webpack_public_path__ + "img/construction_vertical.e3842299.jpg";